import React from 'react';
import { motion } from 'framer-motion';
import { Layout } from '../layout/Layout';
import { Shield, Zap, Users, Globe, Clock, MessageSquare, Brain, Sparkles } from 'lucide-react';

const features = [
  {
    icon: Brain,
    title: 'AI-Gestuurde Interacties',
    description: 'Geavanceerde natuurlijke taalverwerking voor menselijke gesprekken en contextueel begrip.'
  },
  {
    icon: Globe,
    title: 'Meertalige Ondersteuning',
    description: 'Automatische taaldetectie en naadloze communicatie in Nederlands en Engels.'
  },
  {
    icon: Users,
    title: 'Persoonlijke Benadering',
    description: 'Leert van elke interactie voor steeds persoonlijkere klantervaringen.'
  },
  {
    icon: Clock,
    title: '24/7 Beschikbaarheid',
    description: 'Continue ondersteuning zonder wachttijden of onderbrekingen.'
  },
  {
    icon: Shield,
    title: 'Enterprise Beveiliging',
    description: 'Hoogwaardige versleuteling en privacy-bescherming volgens de laatste standaarden.'
  },
  {
    icon: MessageSquare,
    title: 'Omnichannel Integratie',
    description: 'Naadloze integratie met uw bestaande communicatiekanalen en platforms.'
  }
];

export function FeaturesPage() {
  return (
    <Layout>
      <div className="bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          {/* Header */}
          <div className="text-center max-w-3xl mx-auto mb-20">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="inline-flex items-center gap-2 bg-brand-50 text-brand-600 px-4 py-1.5 rounded-full font-medium mb-6"
            >
              <Sparkles size={20} />
              Innovatieve Functionaliteit
            </motion.div>
            <h1 className="text-4xl font-bold text-gray-900 mb-6">
              Geavanceerde AI-Technologie voor Moderne Klantenservice
            </h1>
            <p className="text-xl text-gray-600">
              Ontdek hoe onze AI-chatbot uw klantenservice transformeert met
              geavanceerde functionaliteit en intelligente automatisering.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="w-12 h-12 bg-brand-100 rounded-lg flex items-center justify-center mb-6">
                  <feature.icon className="w-6 h-6 text-brand-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600">
                  {feature.description}
                </p>
              </motion.div>
            ))}
          </div>

          {/* CTA Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mt-20 text-center"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Klaar om te Beginnen?
            </h2>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Transformeer uw klantenservice vandaag nog met onze AI-oplossing.
            </p>
            <button className="bg-brand-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-brand-700 transition-colors">
              Start Gratis Proefperiode
            </button>
          </motion.div>
        </div>
      </div>
    </Layout>
  );
}